module.exports = __webpack_public_path__ + "static/Especialistas_Anymal-141531cd5137ef63bea9562c7fd302a9.png";